export default __webpack_public_path__ + "static/media/Shaka_impact_smoke.1938fa5c.png";